import { render } from "./Amenities.vue?vue&type=template&id=41f94ab0&scoped=true"
import script from "./Amenities.vue?vue&type=script&lang=js"
export * from "./Amenities.vue?vue&type=script&lang=js"

import "./Amenities.vue?vue&type=style&index=0&id=41f94ab0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f94ab0"]])

export default __exports__